const mailchimp = require('./mailChimp');

module.exports = function() {
    return mailchimp
}



// WEBPACK FOOTER //
// ./components/mailChimp/index.js